<template lang='pug'>
.articleCardWithTooltips
  ToolTip(v-if='!(visited == "true")' :tips='data.tips')
  SectionTitle(:sectionText='data.verifiedArticles.title' :displayCardCounter='true' :cardIndex='slideIndex' :cardAmount='length' :displaySeeMoreText='true')
  VerifiedArticlesBlock(:params='params' ref="articles" @slide='slide' @getData='updateLength')
</template>

<script>
import ToolTip from '@/components/modules/tip/popup_tool_tip.vue'
import VerifiedArticlesBlock from '@/components/verified_articles/verified_articles_block.vue'
import SectionTitle from '@/components/modules/section_title/section_title.vue'
export default {
  components: {
    ToolTip,
    VerifiedArticlesBlock,
    SectionTitle
  },
  props: {
    data: Object,
    visited: String,
    params: Object
  },
  data() {
    return {
      slideIndex: 1,
      length: 0
    }
  },
  methods: {
    slide(event) {
      this.slideIndex = event.idx
    },
    updateLength(event) {
      this.length = event.length
    }
  }
}
</script>
